<style scoped>

.zip-button {
  position: relative;
  float: right;
  line-height: 38px;
  padding-left: 1.2rem;
  margin-left: 1rem;
}
</style>

<template>
  <b-modal id="sent-files"
           header-class="anchor-modal"
           :title="title"
           v-model="showModal"
           @hidden="$emit('close', true)"
           hide-footer>
    <b-row>
      <b-col class="mt-3">
        <filter-table :fields="modalFields"
                      :slots="templates"
                      :items="files">
          <template slot="header" v-if="notEmptyFiles && this.type !== 'tax_return'">
            <div class="zip-button">
              <zip-files-button
                :type="type"
                :category="category"
                :entities="entities"
                :numberOfFiles="this.files.length"
              />
            </div>
          </template>
          <template slot="submitted" slot-scope="record">
            {{ record.value|date }}
          </template>
          <template slot="expiration" slot-scope="record">
            {{ record.value|date }}
          </template>
          <template slot="actions" slot-scope="record">
             <a :href="record.row.item.link"
                       class="text-anchor pointer-cursor"
                       target="_blank"
                       v-b-tooltip.hover
                       title="Download file">
               <font-awesome-icon icon="download" class="icon-download"></font-awesome-icon>
            </a>
          </template>
        </filter-table>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import FilterTable from '@/components/utils/FilterTable';
import ZipFilesButton from '@/components/utils/buttons/misc/ZipFilesButton';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

library.add([faDownload]);

export default {
  components: {
    FilterTable,
    ZipFilesButton,
  },
  props: {
    title: { type: String, default: '' },
    files: { default: () => [] },
  },
  data() {
    return {
      showModal: false,
      modalFields: [
        { key: 'submitted', label: 'Submitted', sortable: true },
        { key: 'expiration', label: 'Expiration', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'actions', label: 'Actions', sortable: false, tdClass: 'text-center' },
      ],
      templates: [
        { key: 'submitted' },
        { key: 'expiration' },
        { key: 'actions' },
      ],
    };
  },
  methods: {
    open() {
      this.showModal = true;
    },
    close() {
      this.showModal = false;
    },
  },
  computed: {
    notEmptyFiles() {
      return this.files && this.files.length;
    },
    type() {
      if (this.notEmptyFiles) {
        // if file type is set to 'null' we know it's a tax return
        return this.files[0].type || 'tax_return';
      }
      return '';
    },
    category() {
      if (this.notEmptyFiles) {
        return this.files[0].link.split('/')[5];
      }
      return '';
    },
    entities() {
      if (this.notEmptyFiles) {
        const docCategory = this.files[0].link.split('/')[5];
        if (docCategory === 'entities') {
          return this.files[0].link.split('/')[6];
        }
      }
      return '';
    },
  },
};
</script>

<style scoped>
.icon-download {
  color: #3e88c9;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/documents/SentFilesModal.vue